module.exports = "/_next/static/images/gaurav-1e6e6e7bff3990d9b24d90d46f09809b.png";